import { icon, ButtonProps } from '@/types/models';
import locales_es from '../locales/es.json';

export interface MobileButtonMenu {
  variant: ButtonProps['variant'];
  backgroundColor: string;
  borderColor: string;
  shadow: boolean;
  text: string;
  icon: icon;
  onClick: { (): void };
}

const buttons: MobileButtonMenu[] = [
  {
    variant: 'primary',
    backgroundColor: '#22d29d',
    borderColor: '#199f76',
    shadow: false,
    text: locales_es.newTurn,
    icon: 'calendar',
    onClick: () => {},
  },
  {
    variant: 'primary',
    backgroundColor: '#25ebae',
    borderColor: '#1cb788',
    shadow: false,
    text: locales_es.newPatient,
    icon: 'addressBook',
    onClick: () => {},
  },
  {
    variant: 'primary',
    backgroundColor: '#21dda4',
    borderColor: '#26ffcb',
    shadow: false,
    text: locales_es.newPrescription,
    icon: 'document',
    onClick: () => {},
  },
];

export default buttons;
